// Transform data of the reservation button PDP to json
// in order to use them as cart properties.
const reservationButtons = document.querySelectorAll<HTMLElement>(".reservation-add-to-cart");
if (reservationButtons) {
    reservationButtons.forEach((reservationButton) => {
        reservationButton.dataset.properties = JSON.stringify({
            _sku: reservationButton.dataset.sku,
            Product: reservationButton.dataset.title,
            _handle: reservationButton.dataset.handle
        });
    });
}
